import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "src/components/Button";
import Loader from "src/components/Loader";
import Input from "src/components/form/Input";
import ColorPicker from "src/components/form/color-picker/ColorPicker";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useTeams from "src/hooks/api/services/users/useTeams";
import useModal from "src/hooks/useModal";
import { generateRandomColor } from "src/lib/colors";

const TeamFormModal = ({ t }: Translation) => {
	const { id } = useParams();
	const modal = useModal();
	const navigate = useNavigate();
	const { status, actions, api } = useTeams();
	const [isLoading, setIsLoading] = useState(false);
	const [form, setForm] = useState({
		id: undefined,
		name: "",
		color: generateRandomColor(),
	});

	useEffect(() => {
		modal.setTitle(id ? t("title-edit") : t("title-create"));
		if (id && id !== form.id) {
			setIsLoading(true);
			api.get(`/${id}`).then(({ data }: any) => {
				setIsLoading(false);
				setForm({
					id: data?.data?.hid,
					name: data?.data?.name,
					color: data?.data?.color,
				});
			});
		}

		return () => {
			setForm({ id: undefined, name: "", color: generateRandomColor() });
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onSubmit = (e?: any) => {
		if (e) e.preventDefault();

		if (!form.name) return;

		if (id) {
			actions.update(form, { updateList: true }).then((res) => {
				modal.onClose();
			});
		} else {
			actions.create(form).then((res) => {
				actions.set((state: any) => ({
					...state,
					list: [...(state?.list || []), res],
				}));
				navigate(`/profile/teams`);
				// modal.onClose();
			});
		}
	};

	if (isLoading) {
		return (
			<div className="flex flex-col justify-center items-center p-8">
				<Loader />
			</div>
		);
	}

	return (
		<form {...{ onSubmit }} className=" ">
			<Input
				autoFocus
				name="name"
				label={t("fields.name.label")}
				placeholder={t("fields.name.placeholder")}
				value={form.name}
				onChange={(key, value) =>
					setForm((state: any) => ({
						...state,
						[key]: value,
					}))
				}
			/>
			<ColorPicker
				label={t("fields.color.label")}
				value={form?.color}
				onChange={(color) =>
					setForm((state: any) => ({
						...state,
						color,
					}))
				}
			/>

			<div className="mt-4">
				<Button
					loading={status !== "idle"}
					disabled={!form.name || status !== "idle"}
					className="w-full"
					submit
					type="dark"
				>
					{id ? t("button.edit") : t("button.create")}
				</Button>
			</div>
		</form>
	);
};

TeamFormModal.locale = {
	nl: {
		"title-create": "Team aanmaken",
		"title-edit": "Team aanpassen",
		fields: {
			name: {
				label: "Naam",
				placeholder: "Marketing",
			},
			color: {
				label: "Kleur",
			},
		},
		button: {
			create: "Aanmaken",
			edit: "Opslaan",
		},
	},
	en: {
		"title-create": "Create team",
		"title-edit": "Edit team",
		fields: {
			name: {
				label: "Name",
				placeholder: "Marketing",
			},
			color: {
				label: "Color",
			},
		},
		button: {
			create: "Create",
			edit: "Save",
		},
	},
};

export default withTranslation(TeamFormModal);
